<template>
  <div class="content">
    <el-row :gutter="20">
      <!--部门数据-->
      <el-col :span="4" :xs="24" v-show="adminShow">
        <div class="head-container">
          <el-input
            v-model="deptName"
            placeholder="请输入部门名称"
            clearable
            prefix-icon="el-icon-search"
            style="margin-bottom: 20px"
          />
        </div>
        <div class="head-container">
          <el-tree
            :data="deptOptions"
            :props="defaultProps"
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
            ref="tree"
            default-expand-all
            highlight-current
            @node-click="handleNodeClick"
          />
        </div>
      </el-col>
      <!--用户数据-->
      <el-col :span="adminShow ? 20 : 24 " :xs="24">
        <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
          <el-form-item  prop="username">
            <el-input
              v-model="queryParams.username"
              :placeholder="$t('app.system.user.loginAccount')"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item prop="phone">
            <el-input
              v-model="queryParams.phone"
              :placeholder="$t('app.system.user.phoneNumber')"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item  prop="status">
            <el-select
              v-model="queryParams.status"
              :placeholder="$t('app.system.user.userStatus')"
              clearable
              style="width: 240px"
            >
              <el-option :label="$t('app.system.user.normal')" value="1"></el-option>
              <el-option :label="$t('app.system.user.locked')" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  prop="deptId" v-show="adminShow">
            <el-cascader
              placeholder="请选择部门"
              ref="myCascader"
              :options="deptOptions"
              :props="{ value : 'id' , label : 'name' , checkStrictly: true,emitPath : false,multiple: false }"
              :show-all-levels="false"
              clearable
              v-model="queryParams.deptId"
              @change="handleQuery"
              filterable
            ></el-cascader>
          </el-form-item>
          <el-form-item  prop="userType" v-show="adminShow">
            <el-select
              v-model="queryParams.userType"
              :placeholder="$t('app.system.user.userType')"
              clearable
              style="width: 240px"
            >
              <el-option :label="$t('app.system.user.systemUser')" value="1"></el-option>
              <el-option :label="$t('app.system.user.regularUser')" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  prop="roleId" v-show="adminShow">
            <el-select
              v-model="queryParams.roleId"
              placeholder="请选择角色"
              clearable
              style="width: 240px"
            >
              <el-option v-for="item in selectRoles" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="dateRange"
              style="width: 240px"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="-"
              :start-placeholder="$t('app.system.user.startDate')"
              :end-placeholder="$t('app.system.user.endDate')"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search"  @click="handleQuery">{{ $t('app.common.search') }}</el-button>
            <el-button icon="el-icon-refresh"  @click="resetQuery">{{ $t('app.common.reset') }}</el-button>
          </el-form-item>
        </el-form>

        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="handleAdd"
              v-hasPermi="['system:user:add']"
            >{{ $t('app.common.add') }}</el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button
              type="success"
              icon="el-icon-edit"
              :disabled="single"
              @click="handleUpdate"
              v-hasPermi="['system:user:edit']"
            >{{ $t('app.common.edit') }}</el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button
              type="danger"
              icon="el-icon-delete"
              :disabled="multiple"
              @click="handleDelete"
              v-hasPermi="['system:user:del']"
            >{{ $t('app.common.delete') }}</el-button>
          </el-col>
        </el-row>
        <el-table v-loading="loading" border :data="userList" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50" align="center" />
          <el-table-column :label="$t('app.system.user.userId')" align="center"  prop="id" />
          <el-table-column :label="$t('app.system.user.account')" align="center" prop="username"  :show-overflow-tooltip="true" />
          <el-table-column :label="$t('app.system.user.userName')" align="center" prop="realName" :show-overflow-tooltip="true" />
          <el-table-column :label="$t('app.system.user.userType')" align="center" prop="userType"  :show-overflow-tooltip="true" v-if="adminShow">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.userType=='4'"  type="success">{{ $t('app.system.user.regularUser') }}</el-tag>
              <el-tag v-if="scope.row.userType=='1'">{{ $t('app.system.user.systemUser') }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column :label="$t('app.system.user.department')" align="center" prop="deptName"  :show-overflow-tooltip="true" v-if="adminShow"/>
          <el-table-column :label="$t('app.system.user.position')" align="center"  prop="postName"  :show-overflow-tooltip="true" v-if="adminShow"/>
          <el-table-column :label="$t('app.system.user.role')" align="center"  prop="roleNames" min-width="120px"  :show-overflow-tooltip="true" >
              <template slot-scope="scope">
                <el-tag v-for="item in scope.row.roleNames" :key="item">{{item}}</el-tag>
              </template>
          </el-table-column>
          <el-table-column :label="$t('app.system.user.agentUser')" align="center"  prop="agentUserName"  :show-overflow-tooltip="true" v-if="adminShow"/>
          <el-table-column :label="$t('app.system.user.phone')" align="center"  prop="phone"  width="120" />
          <el-table-column :label="$t('app.system.user.status')" align="center" prop="status"  v-if="checkPermi(['system:user:updateStatus'])" >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == '0'" type="danger">{{ $t('app.common.delete') }}</el-tag>
              <el-switch v-else
                v-model="scope.row.status"
                active-value="1"
                inactive-value="2"
                @change="handleStatusChange(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column :label="$t('app.system.user.createUser')" align="center" prop="createUser" :show-overflow-tooltip="true" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.createUser }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('app.system.user.createTime')" align="center" prop="createTime" width="160">
            <template slot-scope="scope">
              <span>{{ parseTime(scope.row.createTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('app.common.operation')" align="center" width="260" fixed="right">
            <template slot-scope="scope" v-if="scope.row.username !== 'juzi001'">
              <el-button
                size="mini"
                type="primary" plain
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)"
                v-hasPermi="['system:user:edit']"
              >{{ $t('app.common.edit') }}</el-button>
              <el-button
                size="mini"
                type="primary" plain
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
                v-hasPermi="['system:user:del']"
              >{{ $t('app.common.delete') }}</el-button>
              <el-dropdown size="mini" @command="(command) => handleCommand(command, scope.row)" v-hasPermi="['system:user:restPassword', 'system:user:edit']">
                <span class="el-dropdown-link">
                  <i class="el-icon-d-arrow-right el-icon--right"></i>{{ $t('app.common.more') }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="handleResetPwd" icon="el-icon-key"
                    v-hasPermi="['system:user:restPassword']">{{$t('app.system.user.restPassword')}}</el-dropdown-item>
                  <el-dropdown-item command="handleAuthRole" icon="el-icon-circle-check"
                    v-hasPermi="['system:user:edit']">{{$t('app.system.user.authRole')}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          :total="total"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="getList"
        />
      </el-col>
    </el-row>

    <!-- 添加或修改用户配置对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-row>
          <el-col :span="12">
            <el-form-item v-if="form.userId == undefined"  :label="$t('app.system.user.account')" prop="username">
              <el-input v-model="form.username" :placeholder="$t('app.system.user.enterLoginAccount')" maxlength="30" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="form.userId == undefined" :label="$t('app.system.user.password')" prop="password">
              <el-input v-model="form.password" :placeholder="$t('app.system.user.enterLoginPassword')" type="password" maxlength="20" show-password/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row  v-if="adminShow">
          <el-col :span="12">
            <el-form-item :label="$t('app.system.user.department')" prop="deptId">
              <treeselect v-model="form.deptId" :options="deptOptions" :normalizer="normalizer" :show-count="true" :placeholder="$t('app.system.user.selectDepartment')" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('app.system.user.position')">
              <el-select v-model="form.postId" :placeholder="$t('app.system.user.selectPosition')" @change="$forceUpdate()" style="width:100%">
                <el-option
                  v-for="item in postOptions"
                  :key="item.id"
                  :label="item.postName"
                  :value="item.id"
                  :disabled="item.status == 0"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('app.system.user.userName')" prop="realName">
              <el-input v-model="form.realName" :placeholder="$t('app.system.user.enterUserName')" maxlength="30" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('app.system.user.role')" prop="roleIds">
              <el-select v-model="form.roleIds" multiple filterable :placeholder="$t('app.system.user.selectRole')" @change="$forceUpdate()" style="width:100%">
                <el-option
                  v-for="item in roleOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  :disabled="item.status == 0"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('app.system.user.phone')" prop="phone">
              <el-input v-model="form.phone" :placeholder="$t('app.system.user.enterPhoneNumber')" maxlength="11" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('app.system.user.email')" prop="email">
              <el-input v-model="form.email" :placeholder="$t('app.system.user.enterEmail')" maxlength="50" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('app.system.user.status')">
              <el-radio-group v-model="form.status">
                <el-radio label="1">{{ $t('app.system.user.normal') }}</el-radio>
                <el-radio label="2">{{ $t('app.system.user.locked') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('app.system.user.payPassword')" prop="payPassword">
              <el-input v-model="form.payPassword" :placeholder="$t('app.system.user.enterPayPassword')" type="password" maxlength="20" show-password/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="adminShow && form.userType == '1'">
          <el-col :span="24">
            <el-form-item label="套餐组">
              <el-select v-model="form.productGroupIds" multiple filterable placeholder="请选择套餐组" @change="$forceUpdate()" style="width:100%">
                <el-option
                  v-for="item in productGroupData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('app.common.remark')">
              <el-input v-model="form.remark" type="textarea" :placeholder="$t('app.common.enterRemark')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">{{$t('app.common.save')}}</el-button>
        <el-button @click="cancel">{{$t('app.common.cancel')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { userList, getUser, delUser, saveUser, updateUser, restPassword, changeUserStatus, deptTreeSelect ,listRole} from "@/api/api";
import { productGroup } from "@/api/api";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "user",
  components: { Treeselect },
  data() {
    var checkRoles = (rule, value, callback) => {
      if (!value || value.length == 0) {
        return callback(new Error(this.$t('app.system.user.selectRole')));
      }else{
        callback();
      }
    };
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      pageNum:1,
      pageSize:10,
      // 总条数
      total: 0,
      // 用户表格数据
      userList: null,
      // 弹出层标题
      title: "",
      // 部门树选项
      deptOptions: undefined,
      // 是否显示弹出层
      open: false,
      // 部门名称
      deptName: undefined,
      // 默认密码
      initPassword: undefined,
      // 日期范围
      dateRange: [],
      // 岗位选项
      postOptions: [],
      // 角色选项
      roleOptions: [],
      selectRoles:[],
      // 表单参数
      form: {},
      defaultProps: {
        children: "children",
        label: "name"
      },
      //套餐组数据
      productGroupData:[],
      // 查询参数
      queryParams: {
        username: undefined,
        userType:undefined,
        phone: undefined,
        status: undefined,
        deptId: undefined
      },
      // 表单校验
      rules: {
        username: [
          { required: true, message: this.$t('app.system.user.usernameRequired'), trigger: "blur" },
          { min: 2, max: 20, message:  this.$t('app.system.user.usernameLength'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('app.system.user.passwordRequired'), trigger: "blur" },
          { min: 5, max: 20, message: this.$t('app.system.user.passwordLength'), trigger: 'blur' }
        ],
        email: [
          {
            type: "email",
            message: this.$t('app.system.user.emailFormat'),
            trigger: ["blur", "change"]
          }
        ],
        phone: [
          {
            required: true,
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: this.$t('app.system.user.phoneFormat'),
            trigger: "blur"
          }
        ],
        roleIds:[
          {
            required: true,
            validator: checkRoles,
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    adminShow : {
      get() {
          return this.$store.getters.user.userType =='1'
        }
    }
  },
  watch: {
    // 根据名称筛选部门树 监控属性值变化
    deptName(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.initRoles()
    this.getList();
    this.getDeptTree();
    this.selectProductGroup();
  },
  methods: {
    //转换菜单数据结构
    normalizer (node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      };
    },
    initRoles(){
      if(this.adminShow){
        let params = {
          model:{
            isSystem:1,
            roleTypes:['1','3','4','5','6']
          },
          page: 1,
          pageSize: 500,
        };
        listRole(params).then(res => {
          this.selectRoles = res.data.data.records;
        });
      }
    },
    /** 查询用户列表 */
    getList() {
      this.loading = true;
      let params = {
        model:{
          ... this.addDateRange(this.queryParams, this.dateRange),
        },
        page : this.pageNum,
        pageSize : this.pageSize
      }
      userList(params).then(res => {
          this.userList = res.data.data.records;
          this.total = res.data.data.total;
          this.loading = false;
        }
      );
    },
    /** 查询部门下拉树结构 */
    getDeptTree() {
        deptTreeSelect().then(res => {
          this.deptOptions = res.data.data;
        });
    },
    selectProductGroup(){
      if(this.adminShow){
          productGroup().then(res=>{
            this.productGroupData = res.data.data;
          });
      }
    },
    // 筛选节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 节点单击事件
    handleNodeClick(data) {
      this.queryParams.deptId = data.id;
      this.handleQuery();
    },
    // 用户状态修改
    handleStatusChange(row) {
      let text = row.status === "1" ? "启用" : "锁定";
      this.$modal.confirm('确认要"' + text + '""' + row.username + '"用户吗？').then(function() {
        let params = {
          userId:row.userId,
          status:row.status
        }
        return changeUserStatus(params);
      }).then(() => {
        this.$modal.msgSuccess(text + "成功");
      }).catch(function() {
        row.status = row.status === "1" ? "2" : "1";
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        deptId: undefined,
        username: undefined,
        realName: undefined,
        password: undefined,
        payPassword: undefined,
        phone: undefined,
        email: undefined,
        status: "1",
        remark: undefined,
        postId: undefined,
        roleIds: []
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.queryParams.deptId = undefined;
      this.resetForm("queryForm");
      this.$refs.myCascader.$refs.panel.clearCheckedNodes();
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.userId);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    // 更多操作触发
    handleCommand(command, row) {
      switch (command) {
        case "handleResetPwd":
          this.handleResetPwd(row);
          break;
        case "handleAuthRole":
          this.handleAuthRole(row);
          break;
        default:
          break;
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      getUser().then(res => {
        let data = res.data.data;
        this.postOptions = data.posts;
        this.roleOptions = data.roles;
        this.open = true;
        this.title =  this.$t('app.system.user.addUser');
        this.form.userType = '1';
        this.form.password = this.initPassword;
      });
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const userId = row.userId || this.ids[0];
      getUser({userId : userId}).then(res => {
        let data = res.data.data;
        this.form = data.user;
        this.postOptions = data.posts;
        this.roleOptions = data.roles;
        this.form.postId = data.postId;
        this.form.roleIds = data.roleIds;
        this.form.productGroupIds = data.groupIds;
        this.open = true;
        this.title = this.$t('app.system.user.editUser');
        this.form.password = "";
      });
    },
    /** 重置密码按钮操作 */
    handleResetPwd(row) {
      this.$modal.confirm(this.$t('app.system.user.confirmResetPwd', { username: row.username })).then(() =>  {
         restPassword({userId : row.userId}).then(res => {
            this.$modal.msgSuccess(this.$t('app.system.user.resetPwdSuccess'));
            this.getList();
          });
      }).catch(() => {});
      
    },
    /** 分配角色操作 */
    handleAuthRole: function(row) {
      const userId = row.userId;
      this.$router.push("/system/userAuth/role/" + userId);
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.userId != undefined) {
            updateUser(this.form).then(res => {
              this.$modal.msgSuccess(this.$t('app.common.editSuccess'));
              this.open = false;
              this.getList();
            });
          } else {
            saveUser(this.form).then(res => {
              this.$modal.msgSuccess(this.$t('app.common.addSuccess'));
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const userIds = row.userId ? [row.userId]:undefined || this.ids;
      this.$modal.confirm('是否确认删除用户编号为"' + userIds + '"的数据项？').then(function() {
        return delUser(userIds);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    }
  }
};
</script>